<div class="flex flex-col gap-10">
  @if (visibleExecutionControls().length) {
    <div class="flex flex-col gap-3">
      @for (control of visibleExecutionControls(); track control.value.id ?? $index) {
        <div class="rounded-lg -mx-3 px-3 -my-1 py-1" [attr.data-element-id]="control.value.id ?? ''">
          <app-execution-expected-kpis
            [form]="control"
            [platformFeature]="platformFeature()"
            [availableKpis]="availableKpis()"
            [creatorId]="creatorId()"
            [ctaTemplateId]="ctaTemplateId()"
            [isCustomMode]="isCustomMode()"
            [creators]="creators()"
            [isExpanded]="isAllExpanded()"
            [isViewMode]="isViewMode()"
            [gamePlayValues]="gamePlayValues()"
          />
        </div>
      }
    </div>
  } @else if (hasOnlyNoExpectationsExecutions()) {
    <span class="text-sm text-shikenso-purple-base-60">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.kpisStep.noExpectationsOnly' | translate }}
    </span>
  }
</div>
